import { useQuery } from '@tanstack/react-query';
import type { TierCatalogEntry } from '@mondy/shared';
import { api } from '@/api';

const QUERY_KEY = ['payments', 'tiers'] as const;

/**
 * Tier catalog (name + description + features + live Stripe price). Cached
 * for 5min — prices on Stripe are essentially static and the rest is
 * server-hardcoded copy.
 */
export function useTierCatalog() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<{ tiers: TierCatalogEntry[] }>(
        '/api/payments/tiers',
      );
      return res.tiers;
    },
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    retry: 1,
  });
}
